export const ADMIN_PERMISSIONS = {
  dashboardView: "dashboard.view",
  pipelineView: "pipeline.view",
  usersManage: "users.manage",
  subscriptionsManage: "subscriptions.manage",
  uccManage: "ucc.manage",
  marketingView: "marketing.view",
  marketingManage: "marketing.manage",
  marketingPublish: "marketing.publish",
  marketingHubspot: "marketing.hubspot",
  settingsView: "settings.view",
  settingsManage: "settings.manage",
  integrationsView: "integrations.view",
  internalAdminsManage: "internal_admins.manage",
};

export const ADMIN_PERMISSION_LABELS = {
  "dashboard.view": "Dashboard",
  "pipeline.view": "Pipeline / Users",
  "users.manage": "Manage users",
  "subscriptions.manage": "Manage subscriptions",
  "ucc.manage": "UCC management",
  "marketing.view": "Marketing (view)",
  "marketing.manage": "Marketing (manage)",
  "marketing.publish": "Marketing (publish)",
  "marketing.hubspot": "Marketing (HubSpot)",
  "settings.view": "Settings (view)",
  "settings.manage": "Settings (manage)",
  "integrations.view": "Integrations",
  "internal_admins.manage": "Internal admins",
};

export const getAdminPermissionLabel = (permissionKey) =>
  ADMIN_PERMISSION_LABELS[permissionKey] || permissionKey;

export const getStoredAdminPermissions = () => {
  try {
    const raw = localStorage.getItem("admin_permissions");
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const storeAdminPermissions = (permissions = []) => {
  localStorage.setItem(
    "admin_permissions",
    JSON.stringify(Array.isArray(permissions) ? permissions : []),
  );
};

export const hasAdminPermission = (permission, permissions = null) => {
  const list = permissions ?? getStoredAdminPermissions();
  return list.includes(permission);
};

export const canAccessAdminNav = (navKey, permissions = null) => {
  const list = permissions ?? getStoredAdminPermissions();
  const map = {
    dashboard: ADMIN_PERMISSIONS.dashboardView,
    users: ADMIN_PERMISSIONS.pipelineView,
    partners: ADMIN_PERMISSIONS.usersManage,
    marketing: ADMIN_PERMISSIONS.marketingView,
    settings: ADMIN_PERMISSIONS.settingsView,
    internal: ADMIN_PERMISSIONS.internalAdminsManage,
  };
  const required = map[navKey];
  if (!required) {
    return true;
  }
  return list.includes(required);
};
